import React from "react";
import "../../index.css";
import {
  MdClose,
  MdOutlineAttachFile,
} from "react-icons/md";
import { FaFileAlt } from "react-icons/fa";

const formatFileSize = (size) => {
  return `${(size / (1024 * 1024)).toFixed(2)} MB`;
};

const FileUpload = ({
  handleClick,
  handleDrop,
  handleDragOver,
  inputRef,
  handleChange,
  handleRemoveFile,
  files,
}) => {
  return (
    <div className="file-upload-container">
      <div className="support-field support-field--upload">
        <label>
          Attachments / Screenshots <small>(Optional)</small>
        </label>
      </div>

      <div
        className="drop-zone"
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <div className="upload-icon">
          <MdOutlineAttachFile />
        </div>
        <div className="upload-copy">
          {files.length > 0 ? (
            `${files.length} file(s) selected`
          ) : (
            <>
              <strong>
                Upload any screenshots or files that can help us understand the
                issue faster
              </strong>
              <span>
                <button className="link" type="button">
                  Browse files
                </button>{" "}
                - PNG, JPG, PDF, max 10 MB
              </span>
            </>
          )}
        </div>

        <input
          type="file"
          accept=".png,.jpg,.jpeg,.pdf"
          ref={inputRef}
          multiple
          className="file-input"
          onChange={handleChange}
        />
      </div>

      {files.length > 0 && (
        <div className="support-file-list">
          {files.map((file, index) => (
            <div
              className="support-file-item"
              key={`${file.name}-${file.lastModified}-${index}`}
            >
              <FaFileAlt className="support-file-item__icon" />
              <div className="support-file-item__content">
                <span className="support-file-item__name">{file.name}</span>
                <span className="support-file-item__size">
                  {formatFileSize(file.size)}
                </span>
              </div>
              <button
                className="support-file-item__remove"
                type="button"
                aria-label={`Remove ${file.name}`}
                onClick={(event) => {
                  event.stopPropagation();
                  handleRemoveFile(index);
                }}
              >
                <MdClose />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
